































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import * as relazioneMedicaApi from '../../services/relazione-medica-api';
import {
    RelazioneMedicaEditViewModel,
    Attributo,
    AttributoSelector,
} from '../../types';
import validationRulesMixin from '../../components/mixin/validation-rules-mixin';
import operatoreSanitarioSelector from '../selectors/OperatoreSanitarioSelector.vue';
import attributoSelector from '../selectors/AttributoSelector.vue';
import relazioneMedicaEventoList from '../list/RelazioneMedicaEventoList.vue';
import relazioneMedicaResponsabilitaList from '../list/RelazioneMedicaResponsabilitaList.vue';
import relazioneMedicaRelazioneSanitarioList from '../list/RelazioneMedicaRelazioneSanitarioList.vue';
import relazioneMedicaSpesaList from '../list/RelazioneMedicaSpesaList.vue';
import relazioneMedicaPrint from '../print/RelazioneMedicaPrint.vue';
import * as relazioneMedicaRelazioneSanitarioApi from '../../services/relazione-medica-relazione-sanitario-api';
import * as relazioneMedicaResponsabilitaApi from '../../services/relazione-medica-responsabilita-api';
import * as relazioneMedicaSpesaApi from '../../services/relazione-medica-spesa-api';
export default Vue.extend({
    mixins: [validationRulesMixin],

    components: {
        operatoreSanitarioSelector,
        attributoSelector,
        relazioneMedicaEventoList,
        relazioneMedicaRelazioneSanitarioList,
        relazioneMedicaResponsabilitaList,
        relazioneMedicaSpesaList,
        relazioneMedicaPrint,
    },
    props: {
        fullSize: { default: false },
        prestazioneId: { type: Number },
    },
    data(): RelazioneMedicaEditViewModel {
        return {
            item: null,
            isValid: false,
            panels: [0],
            showPrint: false,
        };
    },
    computed: {
        isNew(): boolean {
            return this.item != null && this.item.id === 0;
        },
    },
    methods: {
        async loadData(id: number): Promise<void> {
            if (id > 0) {
                this.item = await relazioneMedicaApi.getByPrestazione(id);
            }

            if (!this.item) this.setNewItem();
        },
        close() {
            this.$emit('close');
        },
        setNewItem() {
            this.item = {
                id: 0,
                version: 0,
                operatoreSanitarioId: 0,
                utenteId: 0,
                prestazioneId: this.prestazioneId,
                tipoIncaricoId: 0,
                tipoRelazioneId: 0,
                relazioneDiParte: false,
                relazioneSpecialistica: false,
                nessoCausale: false,
                perditaChance: false,
                esameObiettivo: '',
                nessoCausaleInterno: false,
                perditaChanceInterno: false,
                noteRichieste: '',
                displayName: this.$i18n.t('labels.nuovo').toString(),
            };
        },
        async save() {
            if (!this.item) {
                return;
            }
            if (this.isNew) {
                await relazioneMedicaApi.create(this.item);
            } else {
                await relazioneMedicaApi.update(this.item);
            }
            await this.loadData(this.prestazioneId);
            this.$emit('save', this.item);
        },
        expandAll() {
            this.panels = [];
            const length = ((this.$refs.expansionPanels as any).items as any[])
                .length;
            for (let i = 0; i < length; i++) {
                this.panels.push(i);
            }
        },
        collapseAll() {
            this.panels = [];
        },
        async print() {
            if (!this.item) return;
            this.item.relazioniSanitari = await relazioneMedicaRelazioneSanitarioApi.getByRelazioneMedica(
                this.item.id
            );
            this.item.responsabilitaAssicurato = await relazioneMedicaResponsabilitaApi.getByRelazioneMedica(
                this.item.id,
                true
            );
            this.item.responsabilitaNonAssicurato = await relazioneMedicaResponsabilitaApi.getByRelazioneMedica(
                this.item.id,
                false
            );
            this.item.spese = await relazioneMedicaSpesaApi.getByRelazioneMedica(
                this.item.id
            );

            this.showPrint = true;
        },
        esameObiettivoSelected(e: Attributo) {
            if (!this.item || !e) return;
            this.item.esameObiettivo =
                (this.item.esameObiettivo ?? '') +
                (this.item.esameObiettivo && this.item.esameObiettivo.length > 0 ? '\n' : '') +
                e.descrizione;

            (this.$refs
                .esameObiettivoSelector as AttributoSelector).clearSelection();
        },
         contestazioniControparteSelected(e: Attributo) {
            if (!this.item || !e) return;
            this.item.contestazioniControparte =
                (this.item.contestazioniControparte ?? '') +
                (this.item.contestazioniControparte && this.item.contestazioniControparte.length > 0 ? '\n' : '') +
                e.descrizione;

            (this.$refs
                .contestazioniControparteSelector as AttributoSelector).clearSelection();
        },

          sintesiCriticitaSelected(e: Attributo) {
            if (!this.item || !e) return;
            this.item.sintesiCriticita =
                (this.item.sintesiCriticita ?? '') +
                (this.item.sintesiCriticita && this.item.sintesiCriticita.length > 0 ? '\n' : '') +
                e.descrizione;

            (this.$refs
                .sintesiCriticitaSelector as AttributoSelector).clearSelection();
        },
          considerazioniMedicoLegaliSelected(e: Attributo) {
            if (!this.item || !e) return;
            this.item.considerazioniMedicoLegali =
                (this.item.considerazioniMedicoLegali ?? '') +
                (this.item.considerazioniMedicoLegali && this.item.considerazioniMedicoLegali.length > 0 ? '\n' : '') +
                e.descrizione;

            (this.$refs
                .considerazioniMedicoLegaliSelector as AttributoSelector).clearSelection();
        },
        
    },
    async mounted() {
        await this.loadData(parseInt(this.$route.params.id));
        setTimeout(() => {
            this.isValid = (this.$refs.form as HTMLFormElement).validate();
        });
    },
    watch: {
        isValid: {
            handler: function (val) {
                this.$emit('validation', val);
            },
            immediate: true,
        },
    },
});
